import { ChevronDown, ChevronUp } from '@aktiia/design-system';
import cx from 'classnames';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SortTypes } from '../../../constants';
import { FetchStatus, SortType } from '../../../enums';
import { ISortProps } from './types';

export const Sort = <T,>({ by, sort, status, baseTranslationKey, updateSort }: ISortProps<T>) => {
  const { t } = useTranslation();
  const loaded = useMemo(() => [FetchStatus.SUCCESS, FetchStatus.FAILURE].includes(status), [status]);
  const onClick = useCallback(() => {
    if (by !== sort.by) {
      updateSort({ by, type: SortType.ASC });
    } else {
      const index = SortTypes.indexOf(sort.type);
      if (index === SortTypes.length - 1) {
        updateSort({ by, type: SortTypes[0] });
      } else {
        updateSort({ by, type: SortTypes[index + 1] });
      }
    }
  }, [by, sort, updateSort]);

  const icon = useMemo(() => {
    if (sort.by === by && sort.type === SortType.DESC) {
      return <ChevronUp className="scale-75" />;
    }

    return <ChevronDown className="scale-75" />;
  }, [sort]);

  return (
    <span
      className={cx('flex items-center cursor-pointer', {
        'text-text-primary': loaded && sort.by === by && sort.type !== SortType.IDLE,
      })}
      onClick={loaded ? onClick : undefined}
    >
      <span className="mr-2">{t(`${baseTranslationKey}.${by}`)}</span>
      {loaded && icon}
    </span>
  );
};
